import React from 'react';
import { motion } from 'framer-motion';

const SocialShare = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="space-y-6"
    >
      {/* Station Info */}
      <div className="bg-black/40 backdrop-blur-lg rounded-xl border border-blue-500/30 p-6">
        <h3 className="text-lg font-bold text-white mb-4">Station Information</h3>
        
        <div className="space-y-3 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-400">Signal Quality:</span>
            <span className="text-green-400 font-medium">HD 1080p</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Broadcast Type:</span>
            <span className="text-blue-400 font-medium">Linear Live</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Schedule:</span>
            <span className="text-white font-medium">24/7 Live</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SocialShare;